export const GLOBAL_USER_ROLES = Object.freeze([
  "admin",
  "standard_user"
]);

export const GLOBAL_USER_ROLE_OPTIONS = Object.freeze([
  { value: "admin", label: "Admin" },
  { value: "standard_user", label: "Standard user" }
]);
